export const enMsdynamics = {
	title: "Microsoft Dynamics 365 Integration",
	connected: "Connected",
	notConnected: "Not Connected",
	connect: "Connect",
	disconnect: "Disconnect",
	configureFieldMapping: "Configure Field Mapping",
	fieldMapping: {
		title: "Dynamics 365 Field Mapping",
		contacts: "Contacts",
		accounts: "Accounts",
		leads: "Leads",
		opportunities: "Opportunities",
		campaignResponses: "Campaign responses",
		campaigns: "Campaigns",
		marketingLists: "Marketing lists",
		ourField: "Signalist Field",
		msdynamicsField: "Dynamics 365 Field",
		active: "Active",
		actions: "Actions",
		addMapping: "Add Mapping",
		restoreDefaults: "Restore default mappings",
		restoreDefaultsTooltip:
			"Adds the standard Dynamics 365 mappings you are missing on this tab. Existing mappings stay untouched.",
		restoreDefaultsNoneAdded: "All default mappings are already configured.",
		restoreDefaultsFailed: "The default mappings could not be restored.",
		saveAll: "Save All",
		selectField: "Select a field",
		noMappings: "No field mappings configured yet.",
		deleteConfirm: "Are you sure you want to delete this mapping?",
		sourceTypeFromRecord: "From record",
		sourceTypeConstant: "Constant value",
		sourceTypeAi: "AI-generated",
		constantPlaceholder: "Enter a literal value",
		constantLabel: 'Constant: "{{value}}"',
		aiBadge: "AI",
		aiConfigure: "Configure",
		aiTargetPlaceholder: "Pick a Dynamics 365 field →",
		aiCreditTooltip: "0.1 credits per lead synced — flat, covers all AI fields",
		aiHintTitle: "AI-enriched fields",
		aiHintBody:
			"Let an AI agent classify, research, or extract a value before syncing. AI enrichment costs 0.1 credits per lead — flat, regardless of how many AI fields you add. The field name will match your selected Dynamics 365 field.",
		aiSaveDisabledTooltip: "Configure AI to save",
		cannotMap: "— Cannot map —",
		relationshipNeedsValueMap:
			"A relationship field can only be filled from a source with a lookup value map, such as Country or State. Pick that source, or another target.",
		valueMap: {
			title: "Written as",
			refresh: "Refresh",
			edit: "Edit",
			done: "Done",
			writeNothing: "— write nothing —",
			unplaced: "Not assigned: {{labels}}",
			unmappedKey: "not written",
			keys: {
				MALE: "male",
				FEMALE: "female",
				INTERESTED: "interested",
				NOT_INTERESTED: "not interested",
				BAD_TIMING: "bad timing",
				WRONG_PERSON: "wrong person",
				UNSUBSCRIBED: "unsubscribed",
				EMAIL: "email",
				LINKEDIN: "LinkedIn",
				PROPOSED: "proposed",
				LAUNCHED: "launched",
				SUSPENDED: "suspended",
				COMPLETED: "completed",
			},
			coverage: {
				COUNTRY_one: "{{count}} country mapped",
				COUNTRY_other: "{{count}} countries mapped",
				STATE_one: "{{count}} state mapped",
				STATE_other: "{{count}} states mapped",
			},
			countryCode: "Code",
			format: {
				EN_NAME: "English names",
				DE_NAME: "German names",
				ISO2: "two-letter country codes",
				ISO3: "three-letter country codes",
				CODE: "state codes (e.g. SN)",
				ISO: "ISO codes (e.g. DE-SN)",
			},
		},
		cannotMapTooltip: "Dynamics 365 computes this attribute — Signalist cannot write to it",
		droppedBySync: "Ignored by every sync",
		droppedBySyncTooltip:
			"This Dynamics 365 field is a relationship, and a relationship can only be filled from a source with a lookup value map, such as Country or State. Every sync skips this mapping, so it writes nothing to the field. Delete it, or map a source with a lookup value map instead.",
		metaBadge: {
			required: "Required",
			multi: "Multi",
			dropdown: "Option set",
			number: "Number",
			calculated: "Calculated",
			readOnly: "Read-only",
			relationship: "Relationship",
		},
		footerSummary: "{{mapped}} fields mapped · {{ai}} AI-enriched",
		footerCreditPill: "+0.1 credits per lead with AI enrichment",
		preview: {
			button: "Test with a lead",
			title: "Test field mapping",
			subtitle:
				"Pick a lead and see exactly which values a sync would write to Dynamics 365, checked against your environment's attribute metadata. Nothing is written — this is a dry run. AI-enriched fields are not executed here; use their test panel instead.",
			cancel: "Cancel",
			createsLabel: "A sync will create",
			createsByEntity: {
				CONTACT: "A sync creates or updates a contact (and its account) in Dynamics 365.",
				ACCOUNT: "A sync creates or updates an account (and its contact) in Dynamics 365.",
				LEAD: "A sync creates a lead in Dynamics 365.",
				OPPORTUNITY: "A sync creates an opportunity in Dynamics 365.",
			},
			prospectLabel: "Lead",
			prospectPlaceholder: "Search leads by name…",
			run: "Run dry run",
			value: "Value",
			emptyValue: "Empty for this lead",
			aiNotRun: "AI — not executed in the dry run",
			inactive: "Inactive",
			fallbacksTitle: "Filled in automatically",
			fallbacksHint:
				"Dynamics 365 needs these attributes; the sync fills them when no active mapping supplies a value.",
			noMappings: "No mappings on this tab.",
			error: "The test failed. Please try again.",
			warnings: {
				missingRequiredTitle: "Missing required attributes",
				missingRequiredHint:
					"Dynamics 365 marks these attributes required, but neither an active mapping nor an AI field nor an automatic fallback supplies a value for this lead. A sync would be rejected:",
			},
			sync: {
				button: "Sync this lead now",
				warningByEntity: {
					CONTACT:
						"End-to-end check: runs a real sync for this lead and shows Dynamics 365's answer. The contact and its account are created or updated (AI fields run and are charged as usual).",
					ACCOUNT:
						"End-to-end check: runs a real sync for this lead and shows Dynamics 365's answer. The account and its contact are created or updated (AI fields run and are charged as usual).",
					LEAD: "End-to-end check: runs a real sync and shows Dynamics 365's answer. A NEW lead is created every time you press this — delete the test records afterwards. AI fields run and are charged as usual.",
					OPPORTUNITY:
						"End-to-end check: runs a real sync and shows Dynamics 365's answer. A NEW opportunity is created every time you press this — delete the test records afterwards. AI fields run and are charged as usual.",
				},
				successTitle: "Dynamics 365 accepted the record — your mapping works.",
				failedTitle: "Dynamics 365 rejected the record:",
				openRecord: "Open in Dynamics 365",
				contactRecord: "Contact {{id}}",
				accountRecord: "Account {{id}}",
				leadRecord: "Lead {{id}}",
				opportunityRecord: "Opportunity {{id}}",
			},
		},
		aiConfigTitle: "Configure AI-enriched field",
		aiConfigSubtitle: "Target: {{label}}",
		aiConfig: {
			configurationTitle: "Configuration",
			promptLabel: "Prompt",
			promptPlaceholder: "Tell the AI how to generate this CRM field value...",
			promptHelp:
				"The AI runs once per sync with this prompt and the prospect and organization data as input.",
			promptMeta: "Editable · pre-filled from attribute metadata",
			defaultPrompt:
				"Generate a value for {{target}}. Use the available prospect and organization context. Allowed values: {{allowedValues}}. Return only the final value.",
			insertVariable: "Insert variable",
			variablesLabel: "Variables",
			allowedValuesTitle: "Allowed values",
			allowedValuesEmpty: "No allowed values returned for this attribute.",
			fallbackLabel: "Fallback value",
			fallbackHelp:
				"Used when the AI cannot determine a confident value. For option sets, the fallback must be one of the numeric option values (for example 1), not the option label.",
			leaveEmpty: "Leave empty",
			behaviorTitle: "Behavior",
			syncReasoningLabel: "Sync reasoning",
			syncReasoningHelp: "Write the AI reasoning to another text attribute.",
			syncReasoningTargetLabel: "Sync reasoning to",
			syncReasoningTargetHelp:
				"Only String and Memo attributes can receive reasoning. Memo is strongly preferred — a String attribute defaults to 100 characters and would truncate it.",
			syncSourceLabel: "Sync source",
			syncSourceHelp: "Write the source list to another text attribute.",
			syncSourceTargetLabel: "Sync source to",
			syncSourceTargetHelp: "Only String and Memo attributes can receive sources.",
			secondaryTargetPlaceholder: "Select a text attribute",
			testTitle: "Test",
			freeDuringSetup: "Free during setup",
			testIntroTitle: "Test this prompt with a prospect from your pipeline",
			testIntroHelp:
				"Load the variables for a prospect, adjust values if needed, and run a free test.",
			prospectLabel: "Prospect",
			prospectPlaceholder: "Search prospects...",
			loadVariables: "Load variables",
			variablesPreviewTitle: "Variables preview",
			noVariables: "Pick a prospect and load variables to preview the prompt data.",
			editData: "Edit data",
			revertEdits: "Revert edits",
			runTest: "Run test",
			rerunTest: "Re-run test",
			testRunHelp: "Test runs are free, do not update the CRM, and do not consume credits.",
			progressLabel: "Load lead data → analyze & match → return result",
			loadingLeadData: "Load prospect data",
			loadingResearch: "Research organization",
			loadingAnalyze: "Analyze & match",
			loadingReturn: "Return result",
			resultTitle: "Result",
			resultReadyTitle: "AI returned a value",
			valueLabel: "Value",
			reasoningLabel: "Reasoning",
			sourcesLabel: "Sources",
			durationLabel: "Duration",
			fallbackUsed: "Fallback was used.",
			finalPrompt: "Final prompt",
			emptyState: "No test run yet.",
			noCredits: "Tests do not consume credits and do not write to the CRM.",
			costReminder: "0.1 credits per lead synced (flat — covers all AI fields)",
			cancel: "Cancel",
			save: "Save AI mapping",
			requiredPrompt: "Prompt is required",
			requiredSecondaryField: "Select a text attribute",
			invalidFallback: "Fallback must be one of the allowed option values",
			testError: "AI test failed. Please try again.",
		},
	},
	tabs: {
		connection: "Connection",
		settings: "Settings",
		dealConfiguration: "Opportunity Configuration",
		leadConfiguration: "Lead Configuration",
		userMapping: "User Mapping",
		syncLogs: "Sync Logs",
	},
	syncTrigger: {
		title: "Sync Prospects to Dynamics 365",
		description: "Choose when prospects should be automatically synchronized to Dynamics 365.",
		DISABLED: "Disabled",
		ON_CAMPAIGN_START: "When campaign starts",
		ON_REPLY: "When prospect replies",
		INHERIT: "Use company default",
		inheritedFrom: "Currently using company setting",
		error: "Failed to update the sync trigger.",
	},
	dealCreationTrigger: {
		title: "Automatic Opportunity Creation",
		description:
			"Choose when opportunities or leads should be automatically created in Dynamics 365 for prospects that already exist. This setting applies to your whole account — Dynamics 365 has no per-list override.",
		DISABLED: "Off",
		ON_RESPONSE: "On Response",
		ON_POSITIVE_RESPONSE: "On Positive Response",
		createAsLead: "Create as Lead instead of Opportunity",
		createAsLeadDescription:
			"When enabled, automatic creation produces a Dataverse Lead instead of an Opportunity.",
		error: "Failed to update the opportunity-creation trigger.",
	},
	dealConfig: {
		title: "Opportunity Defaults",
		description: "Configure default values for new Dynamics 365 opportunities.",
		defaultPipeline: "Default Pipeline",
		defaultStage: "Default Stage",
		salesStagePipelineNote:
			"Your environment runs no opportunity business process flow, so stages come from the Sales Stage option set instead.",
		dealNameTemplate: "Opportunity Topic Template",
		dealNameTemplateHelp:
			"Use {firstName}, {lastName}, {company}, {email}, {title} as placeholders.",
		insertPlaceholder: "Insert placeholder",
		closeDateOffsetDays: "Estimated Close Date Offset (days)",
		closeDateOffsetHelp: "Number of days from today used for the estimated close date (0-3650).",
		defaultOwner: "Default Opportunity Owner",
		saved: "Opportunity configuration saved successfully.",
		saveError: "Failed to save opportunity configuration.",
	},
	leadConfig: {
		title: "Lead Defaults",
		description:
			"Configure default values applied to new Dynamics 365 Leads. Applies when the opportunity-creation trigger has 'Create as Lead' enabled, and when manually creating a Lead from a prospect.",
		leadTopicTemplate: "Lead Topic Template",
		leadTopicTemplateHelp:
			"Fills the lead's Topic (subject). Use {firstName}, {lastName}, {company}, {email}, {title} as placeholders. Left empty, the opportunity topic template is used instead.",
		leadTopicTemplatePlaceholder: "Leave empty to reuse the opportunity topic template",
		defaultOwner: "Default Lead Owner",
		estimatedValue: "Estimated Value",
		estimatedValueHelp:
			"Written to the lead's Budget Amount. Skipped when a LEAD field mapping already produces a value.",
		closeDateOffsetDays: "Estimated Close Date Offset (days)",
		closeDateOffsetHelp:
			"Number of days from today used for the lead's estimated close date (0-3650).",
		saved: "Lead configuration saved successfully.",
		saveError: "Failed to save lead configuration.",
	},
	userMapping: {
		title: "User Mapping",
		description:
			"Map Signalist users to Dynamics 365 users for record ownership. Notes need an owner to appear on the Dynamics timeline, so leaving a sender unmapped can skip their conversation sync.",
		signalistUser: "Signalist User",
		msdynamicsOwner: "Dynamics 365 User",
		selectOwner: "Select a user",
		noUsers: "No sending users found.",
		saved: "User mappings saved successfully.",
		saveError: "Failed to save user mappings.",
		missingPrivileges:
			"This Dynamics user is missing {{privileges}}, so Dynamics will not let them own synced records. Their records go to another owner until they get a security role that can own records (e.g. Salesperson).",
	},
	createDeal: {
		titleDeal: "Create Dynamics 365 Opportunity",
		titleLead: "Create Dynamics 365 Lead",
		submitDeal: "Create Opportunity",
		submitLead: "Create Lead",
		createAsLead: "Create as Lead",
		createAsLeadHelp: "A Dataverse Lead carries the person and the company on one record.",
		dealName: "Opportunity Topic",
		leadTopic: "Lead Topic",
		defaultPipeline: "Pipeline",
		defaultStage: "Stage",
		salesStagePipelineNote:
			"Your environment runs no opportunity business process flow, so stages come from the Sales Stage option set instead.",
		owner: "Owner",
		closeDate: "Estimated Close Date",
		success: "Created in Dynamics 365.",
		error: "Failed to create the record in Dynamics 365.",
	},
	conversationSync: {
		title: "Conversation Sync",
		label: "Sync conversations to Dynamics 365",
		description:
			"When enabled, messages sent to and received from prospects are mirrored as notes on the matching Dynamics 365 contact.",
		success: "Conversation sync setting updated successfully.",
		error: "Failed to update conversation sync setting.",
		accountNotes: "Also attach conversation notes to the account",
		accountNotesDescription:
			"Each conversation note is also written on the Dynamics 365 account the contact belongs to, with the same subject and text. Applies to conversations synced from now on; notes synced before stay on the contact only.",
		accountNotesNeedSync: "Needs “Sync conversations to Dynamics 365”.",
	},
	marketing: {
		title: "Marketing lists & campaigns",
		description:
			"Mirror your Signalist structure into Dynamics 365: each campaign becomes a marketing list, each list becomes a campaign.",
		marketingLists: "Create a marketing list per campaign",
		marketingListsDescription:
			"Every campaign a prospect is assigned to gets a static marketing list in Dynamics 365, and each synced contact is added to the one for their campaign. Set which fields it fills under Field mapping → Marketing lists.",
		campaigns: "Create a campaign per list",
		campaignsDescription:
			"Every Signalist list gets a Dynamics 365 campaign, and that list's marketing lists are attached to it. Its start, end and status follow the list's campaigns; set which fields it fills under Field mapping → Campaigns.",
		campaignResponses: "Save replies with a sentiment as campaign responses",
		campaignResponsesDescription:
			"Every received email or LinkedIn reply whose sentiment is not neutral becomes a campaign response on the campaign of the lead's list, linked to the contact. Set which fields it fills under Field mapping → Campaign responses.",
		campaignResponsesNeedCampaigns:
			"A campaign response belongs to a campaign, so this needs “Create a campaign per list”.",
		success: "Marketing settings updated successfully.",
		error: "Failed to update the marketing settings.",
	},
	oauth: {
		connectWithDynamics: "Connect with Dynamics 365",
		connectedViaOAuth: "Connected via Microsoft Entra ID",
		environmentUrl: "Environment URL",
		environmentUrlDescription:
			"A Dynamics 365 connection is scoped to one Dataverse environment, so we need its URL before you sign in with Microsoft.",
		environmentUrlHelp:
			"Find it in Power Platform admin center → Environments → your environment. It looks like https://org1234.crm4.dynamics.com.",
		environmentUrlInvalid:
			"Enter a Dynamics 365 environment URL, for example https://org1234.crm4.dynamics.com",
		tenantId: "Tenant",
		msdynamicsUserId: "Connected user",
		tokenRefresh: "Token refreshes automatically",
		disconnectTitle: "Disconnect Dynamics 365?",
		disconnectBody: "This will remove the connection. Dynamics 365 syncing will stop.",
		connectError: "Failed to generate the authorization URL",
		alreadyDisconnected: "Dynamics 365 is already disconnected.",
		disconnectError: "Failed to disconnect from Dynamics 365.",
	},
	syncLogs: {
		description: "View the history of data synchronization between Signalist and Dynamics 365.",
		filterByEntity: "Filter by Entity",
		allEntities: "All Entities",
		entityType: "Entity Type",
		status: "Status",
		synced: "Synced",
		failed: "Failed",
		error: "Error",
		startedAt: "Started At",
		completedAt: "Completed At",
		noLogs: "No sync logs found.",
	},
	resync: {
		title: "Resync with Dynamics 365",
		description:
			"Re-push every already-synced prospect to Dynamics 365 using your current field mapping. Useful after you add or change mapped fields.",
		button: "Resync now",
		confirmTitle: "Resync with Dynamics 365?",
		confirmBody:
			"This will re-push every prospect that is already synced to Dynamics 365 using your current field mapping. Continue?",
		confirmCta: "Resync",
		success: "Re-syncing {{count}} contact(s) to Dynamics 365. Check the sync log for progress.",
		empty: "No already-synced prospects found.",
		error: "Failed to queue resync. Please try again.",
	},
};
